import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card-footer px-9 pt-0",
  id: "onboarding-accordion"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onClick", "id", "data-bs-target", "aria-controls"]
const _hoisted_6 = ["id", "aria-labelledby"]
const _hoisted_7 = { class: "accordion-body" }
const _hoisted_8 = { class: "responsive-accordion-body" }
const _hoisted_9 = {
  key: 0,
  class: "video-container rounded-1 overflow-hidden bg-inactive"
}
const _hoisted_10 = ["id", "src"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "fs-4 fw-bolder" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = ["onClick", "target", "href"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "mt-7 mb-3 ms-n2"
}
const _hoisted_25 = {
  key: 0,
  class: "title d-flex mb-2"
}
const _hoisted_26 = { class: "m-0 fw-bold white-space-pre-line" }
const _hoisted_27 = {
  key: 1,
  class: "h2 m-0 a-bold"
}
const _hoisted_28 = {
  key: 1,
  class: "paragraph d-flex"
}
const _hoisted_29 = {
  key: 0,
  class: "m-0 mx-2 fw-bold"
}
const _hoisted_30 = { class: "m-0 fw-bold white-space-pre-line" }
const _hoisted_31 = {
  key: 1,
  class: "m-0 a-bold fw-bolder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OnboardingStepsTitle = _resolveComponent("OnboardingStepsTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapping, (stepBlock, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: String(_ctx.progress)+index
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "accordion-item",
          id: 'accordion-item-' + index
        }, [
          _createElementVNode("div", {
            class: "w-100",
            id: 'accordion-item-top-' + index
          }, null, 8, _hoisted_3),
          _createElementVNode("h2", {
            class: "mo-accordion-header",
            id: 'heading' + index
          }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.handleAccordionButtonClick(index)),
              id: 'accordion-button-' + index,
              class: "accordion-button collapsed border-top border-top-1 mt-n1px",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": '#collapse' + index,
              "aria-controls": 'collapse' + index
            }, [
              _createVNode(_component_OnboardingStepsTitle, {
                title: _ctx.steps[stepBlock].step_title,
                isCompleted: _ctx.progress[stepBlock],
                isIndexed: _ctx.steps[stepBlock].isIndexed,
                index: index + 1
              }, null, 8, ["title", "isCompleted", "isIndexed", "index"])
            ], 8, _hoisted_5)
          ], 8, _hoisted_4),
          _createElementVNode("div", {
            id: 'collapse' + index,
            class: "accordion-collapse collapse",
            "aria-labelledby": 'heading' + index,
            "data-bs-parent": "#onboarding-accordion"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.steps[stepBlock].step_video_url || 'step_image_index' in _ctx.steps[stepBlock])
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["pe-4", [_ctx.steps[stepBlock].step_header_text ? '' : 'w-100']])
                    }, [
                      (_ctx.steps[stepBlock].step_video_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("iframe", {
                              allow: "fullscreen;",
                              id: 'home-youtube-iframe' + index,
                              width: "100%",
                              height: "min-content",
                              src: _ctx.steps[stepBlock].step_video_url
                            }, "\n                                    ", 8, _hoisted_10)
                          ]))
                        : ('step_image_index' in _ctx.steps[stepBlock])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: "w-100 h-auto rounded-1 overflow-hidden bg-inactive",
                              src: _ctx.originUrl + '/assets/img/onboarding/header_img_' + _ctx.steps[stepBlock].step_image_index + '.png',
                              alt: _ctx.steps[stepBlock].step_image_index
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.steps[stepBlock].step_header_text)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["ps-4", [_ctx.steps[stepBlock].step_video_url || _ctx.steps[stepBlock].step_image_index ? '' : 'w-100']])
                    }, [
                      (_ctx.steps[stepBlock].step_header_type !== 'list' && _ctx.steps[stepBlock].step_header_type !== 'attention')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.steps[stepBlock].step_header_text, (row) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "fs-6 fw-bold white-space-pre-line",
                              key: row
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (block) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (block.text_type === 'simple')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(block.text), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (block.text_type === 'hyperlink')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: block,
                                        class: "hyperlink",
                                        target: "_blank",
                                        href: block.url
                                      }, _toDisplayString(block.text), 9, _hoisted_12))
                                    : _createCommentVNode("", true),
                                  (block.text_type === 'simple_bold')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: block,
                                        class: "a-bold fw-boldest"
                                      }, _toDisplayString(block.text), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256)),
                              _hoisted_13
                            ]))
                          }), 128))
                        : _createCommentVNode("", true),
                      (_ctx.steps[stepBlock].step_header_type === 'list' || _ctx.steps[stepBlock].step_header_type === 'attention')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.steps[stepBlock].step_header_text, (row) => {
                            return (_openBlock(), _createElementBlock("ul", {
                              class: "fs-6 fw-bold white-space-pre-line",
                              key: row
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (block) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: block,
                                  class: "my-1"
                                }, [
                                  (block.text_type === 'simple')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(block.text), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (block.text_type === 'hyperlink')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: block,
                                        class: "hyperlink",
                                        target: "_blank",
                                        href: block.url
                                      }, _toDisplayString(block.text), 9, _hoisted_14))
                                    : _createCommentVNode("", true),
                                  (block.text_type === 'simple_bold')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: block,
                                        class: "fw-boldest"
                                      }, _toDisplayString(block.text), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _hoisted_15
                            ]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex flex-column", [{ 'mt-14': _ctx.steps[stepBlock].step_body_type !== 'attention' }, _ctx.steps[stepBlock].step_body_type]])
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.steps[stepBlock].step_body_title), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps[stepBlock].step_body_text, (row) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "fs-6 fw-bold my-2",
                      key: row
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (block) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (block.text_type === 'simple')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(block.text), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (block.text_type === 'hyperlink')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: block,
                                class: "hyperlink",
                                target: "_blank",
                                href: block.url
                              }, _toDisplayString(block.text), 9, _hoisted_17))
                            : _createCommentVNode("", true),
                          (block.text_type === 'simple_bold')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: block,
                                class: "fw-boldest a-bold"
                              }, _toDisplayString(block.text), 1))
                            : _createCommentVNode("", true),
                          (block.text_type === 'handle_action')
                            ? (_openBlock(), _createElementBlock("a", {
                                onClick: ($event: any) => (_ctx.handleAction(block.url)),
                                key: block,
                                class: "hyperlink"
                              }, _toDisplayString(block.text), 9, _hoisted_18))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256)),
                      _hoisted_19
                    ]))
                  }), 128))
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([" d-flex flex-row gap-6", [{ 'mt-6': !_ctx.getAreAllCompleted() }]])
              }, [
                (_ctx.steps[stepBlock].action_button)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.pauseCurrentVideo(index)),
                      class: "blue-button",
                      target: _ctx.steps[stepBlock].action_button.openInCurrentPage ? '_self' : '_blank',
                      href: _ctx.steps[stepBlock].action_button.url
                    }, _toDisplayString(_ctx.steps[stepBlock].action_button.text), 9, _hoisted_20))
                  : _createCommentVNode("", true),
                (!_ctx.getAreAllCompleted())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.getIsLastIncomplete() && !_ctx.progress[stepBlock])
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => {_ctx.updateStepState(stepBlock); _ctx.pauseCurrentVideo(index); _ctx.handleGuideCompletion()},
                            class: "green-button",
                            type: "button"
                          }, _toDisplayString(_ctx.lastStepCompletionButtonText), 9, _hoisted_21))
                        : (_ctx.progress[stepBlock])
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => {_ctx.forceNextStep(); _ctx.pauseCurrentVideo(index)},
                              class: "green-button",
                              type: "button"
                            }, " Next Step ", 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: ($event: any) => {_ctx.updateStepState(stepBlock); _ctx.forceNextStep(); _ctx.pauseCurrentVideo(index)},
                              class: "green-button",
                              type: "button"
                            }, " Mark Step as Complete ", 8, _hoisted_23))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 8, _hoisted_6)
        ], 8, _hoisted_2), [
          [_vShow, _ctx.handleFinishingStep(stepBlock)]
        ]),
        (_ctx.steps[stepBlock].separator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_ctx.steps[stepBlock].separator.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("h2", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps[stepBlock].separator.title, (titleBlock, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: String(titleBlock) + index
                        }, [
                          (titleBlock.text_type === 'simple')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(titleBlock.text), 1)
                              ], 64))
                            : (titleBlock.text_type === 'simple_bold')
                              ? (_openBlock(), _createElementBlock("a", _hoisted_27, _toDisplayString(titleBlock.text), 1))
                              : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.steps[stepBlock].separator.paragraph)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_ctx.steps[stepBlock].separator.isParagraphAsterisked)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, "*"))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps[stepBlock].separator.paragraph, (paragraphBlock, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: String(paragraphBlock) + index
                        }, [
                          (paragraphBlock.text_type === 'simple')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(paragraphBlock.text), 1)
                              ], 64))
                            : (paragraphBlock.text_type === 'simple_bold')
                              ? (_openBlock(), _createElementBlock("a", _hoisted_31, _toDisplayString(paragraphBlock.text), 1))
                              : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}